import actions from "./actions";
import state from "./states";
import mutations from "./mutations";

const AdminPartnerModule = {
  namespaced: true,
  actions,
  state,
  mutations,
};

export default AdminPartnerModule;